module.exports = __webpack_public_path__ + "img/tj.da3c22a5.png";